/** LightOccluder2D parser: Node2D, the occluder polygon reference and the masks. */
import { parseNode2D } from '../../base/node2d/parser';
import { intOr, boolOr } from '../../../parser/valueParsers';
export function parseLightOccluder2D(heading, properties) {
    const baseProperties = parseNode2D(heading, properties);
    return {
        ...baseProperties,
        occluder: properties.occluder,
        light_mask: intOr(properties.light_mask, 1, 'LightOccluder2D.light_mask'),
        sdf_collision: boolOr(properties.sdf_collision, true, 'LightOccluder2D.sdf_collision'),
        occluder_light_mask: intOr(properties.occluder_light_mask, 1, 'LightOccluder2D.occluder_light_mask'),
    };
}
//# sourceMappingURL=parser.js.map